import { Component, input, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-breadcrumbs-menu',
  templateUrl: './breadcrumbs-menu.component.html',
  styleUrls: ['./breadcrumbs-menu.component.scss']
})
export class BreadcrumbsMenuComponent {
  readonly list = input<any[]>([]);

  readonly stepChanged = output<any>();
}
